import { CommunityDiscussComments } from "../models/CommunityDiscussComments";
import { CommentsGroup } from "../utils/CommentsGroup";
import { GroupDate } from "../utils/DateTransform";
import { CommunityComment } from "./CommunityComment";

type Props = {
    comments: CommunityDiscussComments[];
    onReply: (comment: CommunityDiscussComments) => void;
    onReact: (comment: CommunityDiscussComments) => void;
}

export const CommunityCommentsWrapper = ({ comments, onReply, onReact }: Props) => {
    const _commentsByDate = CommentsGroup(comments);
    return (
        <>
        {Object.keys(_commentsByDate).map((date, i) => (
            <>
                <div className="community-separator" key={`${date}_${i}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="372" height="1" viewBox="0 0 372 1" fill="none">
                        <path d="M0 0.5H372" stroke="#E9E9E9"/>
                    </svg>
                    <span>
                        {GroupDate(date)}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="372" height="1" viewBox="0 0 372 1" fill="none">
                        <path d="M0 0.5H372" stroke="#E9E9E9"/>
                    </svg>
                </div>
                {
                    _commentsByDate[date].map((c, i) => (
                        <CommunityComment comment={c} key={i} onReply={() => onReply(c)} onReact={() => onReact(c)}/>
                    ))
                }
            </>
        ))}
        </>
    )
}